import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

export type MinimalInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string
  error?: string
  onEnterPress?: () => void
  delay?: number
  wrapperClassName?: string
}

export const MinimalInput = forwardRef<HTMLInputElement, MinimalInputProps>(
  ({ label, error, onEnterPress, delay = 0, wrapperClassName, className, onKeyDown, ...props }, ref) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter' && onEnterPress) {
        e.preventDefault()
        onEnterPress()
      }
      onKeyDown?.(e)
    }

    return (
      <div
        className={cn('space-y-2 wizard-stagger', wrapperClassName)}
        style={delay > 0 ? { animationDelay: `${delay}ms` } : undefined}
      >
        <label className="block text-sm text-muted-foreground/80">
          {label}
        </label>
        <input
          ref={ref}
          className={cn(
            'w-full bg-transparent border-b border-border/40 pb-2 text-foreground text-base',
            'placeholder:text-muted-foreground/40 focus:outline-none focus:border-foreground/60',
            'transition-colors',
            className
          )}
          onKeyDown={handleKeyDown}
          {...props}
        />
        {error && <p className="text-xs text-destructive">{error}</p>}
      </div>
    )
  }
)

MinimalInput.displayName = 'MinimalInput'
